import { Contact } from "api/models";

export type ContactBookOption = {
  label: string;
  value: string;
  phone_number?: string;
  email?: string;
  company_name?: string;
};

export const mapContactBookResults = (contacts: Contact[] = []): ContactBookOption[] =>
  contacts.map((contact) => ({
    label: contact.name,
    value: contact.name,
    phone_number: contact.phone_number,
    email: contact.email,
    company_name: contact.company_name,
  }));

/** Ensures a free-typed / persisted contact name appears in options (react-select requires a matching option). */
export function buildContactSelectOptions({
  mapped,
  contactName,
}: {
  mapped: ContactBookOption[];
  contactName?: string | null;
}): ContactBookOption[] {
  if (!contactName) {
    return mapped;
  }

  if (mapped.some((option) => option.value === contactName)) {
    return mapped;
  }

  return [{ label: contactName, value: contactName }, ...mapped];
}
